export const AUDIO_CONSENT_KEY = 'percy_audio_consent_given';
export const NARRATION_ENABLED_KEY = 'percy_narration_enabled';
export const MUSIC_ENABLED_KEY = 'percy_music_enabled';
export const SFX_ENABLED_KEY = 'percy_sfx_enabled';

export type AudioChoice = 'hear' | 'read';

export function hasAudioConsent(): boolean {
  try {
    return localStorage.getItem(AUDIO_CONSENT_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setAudioConsent(choice: AudioChoice): void {
  const enabled = choice === 'hear';
  try {
    localStorage.setItem(AUDIO_CONSENT_KEY, 'true');
    localStorage.setItem(NARRATION_ENABLED_KEY, String(enabled));
    localStorage.setItem(MUSIC_ENABLED_KEY, String(enabled));
    localStorage.setItem(SFX_ENABLED_KEY, String(enabled));
  } catch {
    /* noop — sessionStorage unavailable */
  }
  window.dispatchEvent(new CustomEvent('percy-audio-consent', { detail: { enabled } }));
}
